// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.titleHeadWallet {
  margin-top: 25px;
}
.walletHeader {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 30px;
  margin-bottom: 23px;
}

#walletTitle {
  font-family: Silvana;
  font-weight: 300;
  font-size: 60px;
  color: var(--main-link-color);
  margin-top: 0;
  margin-bottom: 0;
  line-height: 60px;
}

#walletAddProduct a {
  color: initial;
  display: flex;
  align-items: center;
  font-size: 9px;
  letter-spacing: 0.9px;
  text-transform: uppercase;
  color: var(--footer-selected-color);
}

#walletAddProduct a svg {
  width: 44px;
  height: 44px;
  margin-left: 12px;
}

#walletProductBlock,
.walletProductBlock {
  display: flex;
  flex-direction: column;
  margin-bottom: 10px;
  background-color: var(--background-color);
  height: 28vh;
  color: var(--footer-selected-color);
}

#walletProductName,
.walletProductName {
	font-weight: bold;
  font-size: 25px;
  text-transform: uppercase;
  padding-top: 15px;
  text-align: center;
}

#walletProductModel,
.walletProductModel {
	font-family: Silvana;
  font-weight: 300;
  text-align: center;
  margin-top: 5px;
}

#walletProductPicture,
.walletProductPicture {
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  flex-grow: 1;
}

/*//////////*/
.productCardContent{
  display: flex;
  flex-direction: column;
  height: 28vh;
  color: #3c3c3b;
  align-items: center;
  justify-content: space-around;
  background-color: #eee;

}
.productCardPicture{
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  flex-grow: 1;
  width: 100%;
}

.productCardContent{
  font-family: OpenSans;
}

.productCardTitle {
  text-align: center;
  border-bottom: rgb(255, 158, 23) solid 1px;
}

.productCard {
  cursor: pointer;
  position: relative;
  background-color: #eee;
  transition: transform 0.5s;
}

.productCard::after {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  transition: opacity 2s cubic-bezier(0.165, 0.84, 0.44, 1);
  box-shadow: 0 8px 17px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.15);
  content: "";
  opacity: 0;
  z-index: -1;
}
.productCard:hover::after, .productCardContent:focus::after {
  opacity: 1;
}

.tabBtn {
  background-color: white;
  width: 100%;
  border: solid 1px var(--main-hg-color);
  font-size: 12px;
  font-weight: bold;
  text-transform: uppercase;
  margin-top: 20px;
  padding: var(--buttonPadding);
  cursor: pointer;
  display: block;
  transition: background-color 0.5s ease-in-out;
}

.tabBtn:disabled {
  opacity: 0.5;
}

.tabBtnSelected {
  background-color: var(--main-hg-color);
}

.invoiceMissing {
  color: black;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
  font-weight: lighter;
  border: 1px solid black;
  border-radius: 25px;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 25px;
  padding: 10px;
  font-style: italic ;
}

.invoiceMissing p{
  margin: 0;
}

.productCardHeader {
  justify-content: flex-end !important;
}

.invoiceVerif {
  color: red;
  border: 1px solid red;
  border-radius: 25px;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
  font-weight: lighter;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 25px;
  padding: 10px;
  background-color: rgba(252,0,0,0.1);
}

.invoiceVerif p{
  margin: 0;
}


.container__switch {
  width: 192px;
  height: 42px;
  background: #FFFFFF 0% 0% no-repeat padding-box;
  border: 1px solid #121212;
  border-radius: 10px;
  opacity: 0.1;
  display: flex;
}

.container__switch__left {
  text-align: left;
  font-size: 15px;
  font-weight: 600;
  letter-spacing: 0px;
  color: #FFFFFF;
  opacity: 1;
  left: 241px;
  width: 53px;
  height: 19px;
  width: 50%;
  font-family: 'Plus Jakarta Sans';
}

.container__switch__right {
  text-align: left;
  font-weight: 600;
  font-size: 15px;
  letter-spacing: 0px;
  color: #FFFFFF;
  opacity: 1;
  left: 241px;
  width: 53px;
  height: 19px;
  width: 50%;
  font-family: 'Plus Jakarta Sans';
}

.container__switcher {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center
}

.container__switcher span.switcher {
  position: relative;
  width: 192px;
  height: 42px;
  border-radius: 10px;
  margin: 40px 0
}

.container__switcher span.switcher input {
  appearance: none;
  position: relative;
  width: 192px;
  height: 42px;
  border-radius: 10px;
  background-color: transparent;
  outline: 0;
  font-family: Poppins;
  cursor: pointer;
  border: 1px solid rgba(18,18,18,0.1);
  border-radius: 10px;
  display: flex;
}

@media (max-width: 600px) {
  .container__switcher span.switcher input {
    width:100%
  }
}

.container__switcher span.switcher input:after,.container__switcher span.switcher input:before {
  z-index: 2;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  color: #fff
}

.container__switcher span.switcher input:before {
  content: var(--jour-actuel);
  left: 20px;
  font-family: 'Plus Jakarta Sans';
  font-size: 15px;
  width: 100%;
  font-weight: 700;
  height: 100%;
  left: 0;
  padding: 8px;
  padding-left: 21px;
}

.container__switcher span.switcher input:after {
  content: var(--jour-suivant);
  right: 20px;
  font-family: 'Plus Jakarta Sans';
  font-size: 15px;
  letter-spacing: 0;
  font-weight: 700;
}

.container__switcher span.switcher label {
  z-index: 1;
  position: absolute;
  top: 0;
  bottom: -3px;
  border-radius: 8px
}

.container__switcher span.switcher.switcher-1 input {
  transition: .25s -.1s
}

.container__switcher span.switcher.switcher-1 input:checked {
  background-color: #fff
}

.container__switcher span.switcher.switcher-1 input:checked:before {
  color: #fff;
  transition: color .5s .2s
}

.container__switcher span.switcher.switcher-1 input:checked:after {
  color: #000000;
  transition: color .5s
}

.container__switcher span.switcher.switcher-1 input:checked+label {
  left: 5px;
  top: 3px;
  right: 98px;
  height: 36px;
  background-color: var(--main-hg-color);
  transition: left .5s,right .4s .2s;
  box-shadow: 0 4px 10px rgba(0,0,0,.1)
}

@media (max-width: 300px) {
  .container__switcher span.switcher.switcher-1 input:checked+label {
    right:100px
  }
}

.container__switcher span.switcher.switcher-1 input:not(:checked) {
  transition: background .5s -.1s
}

.container__switcher span.switcher.switcher-1 input:not(:checked):before {
  background-color: var(--main-hg-color);
  transition: color .5s
}

.container__switcher span.switcher.switcher-1 input:not(:checked):after {
  color: #fff;
  transition: color .5s .2s
}

.container__switcher span.switcher.switcher-1 input:not(:checked)+label {
  left: 102px;
  top: 3px;
  height: 36px;
  right: 5px;
  background-color: var(--main-hg-color);
  transition: left .4s .2s,right .5s,background .35s -.1s;
  box-shadow: 0 4px 10px rgba(0,0,0,.1)
}

@media (max-width: 600px) {
  .container__switcher span.switcher.switcher-1 input:not(:checked)+label {
    left:50% !important;
  }

  .container__switcher span.switcher.switcher-1 input:checked+label {
    right: 50%;
  }
}

@media (max-width: 300px) {
  .container__switcher span.switcher.switcher-1 input:not(:checked) + label {
    left:100px
  }
}

.container__toggle__switch {
  height: fit-content;
  margin-top: 20px;
  margin-bottom: 20px;
}
.container__toggle__switch button {
  height: fit-content;
  margin-top: 0;
  padding: 6px 5px;
}

.container__toggle__switch button:first-child {
  border-radius: 10px 0px 0 10px;
}

.container__toggle__switch button:last-child {
  border-radius: 0 10px 10px 0;
}

.togglebutton {
  padding-top: 28px;
}

.deleteBanner {
  border: solid 1px rgb(255, 158, 23);
  border-radius: 10px;
  padding: 5px;
  background-color: rgba(255, 158, 23, 0.3);
  color: black;
  /*width: 30%;*/
  display: flex;
  justify-content: space-between;
}

.deleteCancel {
  background-color: transparent;
  border: solid 1px rgb(255, 158, 23);
  border-radius: 10px;
  font-size: 12px;
  font-weight: bold;
  text-transform: uppercase;
  padding: 10px;
  cursor: pointer;
  transition: background-color 0.3s ease
}

.deleteCancel:hover {
  background-color: rgba(255, 158, 23, 0.3);
}

.containerLanguage {
  max-width: calc(100vw - 50px);
  margin: 0 auto;
  z-index: 11;
}
.selectLanguage {
  margin-top: 5px;
  width: 5%;
}

@media (max-width: 1200px) {
  .selectLanguage {
    width: 10%;
  }
}

@media (max-width: 600px) {
  .selectLanguage {
    width: 20%;
  }
}

.ui.selection.active.dropdown:hover,
.ui.selection.active.dropdown:focus,
.ui.selection.dropdown:focus,
.ui.selection.active.dropdown .menu
{
  border-color: rgb(255, 158, 23)!important;
  box-shadow: 0 2px 3px 0 rgba(255, 158, 23,.15)!important;
}

.walletProducts:last-child {
    margin-bottom: 50px;
}
`, "",{"version":3,"sources":["webpack://./src/styles/wallet.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;EACf,6BAA6B;EAC7B,aAAa;EACb,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,qBAAqB;EACrB,yBAAyB;EACzB,mCAAmC;AACrC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,yCAAyC;EACzC,YAAY;EACZ,mCAAmC;AACrC;;AAEA;;CAEC,iBAAiB;EAChB,eAAe;EACf,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;;CAEC,oBAAoB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;;EAEE,4BAA4B;EAC5B,2BAA2B;EAC3B,wBAAwB;EACxB,YAAY;AACd;;AAEA,aAAa;AACb;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,6BAA6B;EAC7B,sBAAsB;;AAExB;AACA;EACE,4BAA4B;EAC5B,2BAA2B;EAC3B,wBAAwB;EACxB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,sBAAsB;EACtB,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,yDAAyD;EACzD,6EAA6E;EAC7E,WAAW;EACX,UAAU;EACV,WAAW;AACb;AACA;EACE,UAAU;AACZ;;AAEA;EACE,uBAAuB;EACvB,WAAW;EACX,sCAAsC;EACtC,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,gBAAgB;EAChB,6BAA6B;EAC7B,eAAe;EACf,cAAc;EACd,6CAA6C;AAC/C;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,YAAY;EACZ,8JAA8J;EAC9J,oBAAoB;EACpB,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,UAAU;EACV,qBAAqB;EACrB,mBAAmB;EACnB,8JAA8J;EAC9J,oBAAoB;EACpB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,mCAAmC;AACrC;;AAEA;EACE,SAAS;AACX;;;AAGA;EACE,YAAY;EACZ,YAAY;EACZ,+CAA+C;EAC/C,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,UAAU;EACV,WAAW;EACX,WAAW;EACX,YAAY;EACZ,UAAU;EACV,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,UAAU;EACV,WAAW;EACX,WAAW;EACX,YAAY;EACZ,UAAU;EACV,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB;AACF;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB;AACF;;AAEA;EAGE,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,6BAA6B;EAC7B,UAAU;EACV,oBAAoB;EACpB,eAAe;EACf,oCAAoC;EACpC,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE;IACE;EACF;AACF;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;EAC3B;AACF;;AAEA;EACE,2BAA2B;EAC3B,UAAU;EACV,gCAAgC;EAChC,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,OAAO;EACP,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;EAC5B,WAAW;EACX,gCAAgC;EAChC,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,MAAM;EACN,YAAY;EACZ;AACF;;AAEA;EACE;AACF;;AAEA;EACE;AACF;;AAEA;EACE,WAAW;EACX;AACF;;AAEA;EACE,cAAc;EACd;AACF;;AAEA;EACE,SAAS;EACT,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,sCAAsC;EACtC,kCAAkC;EAClC;AACF;;AAEA;EACE;IACE;EACF;AACF;;AAEA;EACE;AACF;;AAEA;EACE,sCAAsC;EACtC;AACF;;AAEA;EACE,WAAW;EACX;AACF;;AAEA;EACE,WAAW;EACX,QAAQ;EACR,YAAY;EACZ,UAAU;EACV,sCAAsC;EACtC,uDAAuD;EACvD;AACF;;AAEA;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE;EACF;AACF;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mCAAmC;EACnC,mBAAmB;EACnB,YAAY;EACZ,yCAAyC;EACzC,YAAY;EACZ,cAAc;EACd,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,6BAA6B;EAC7B,mCAAmC;EACnC,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,aAAa;EACb,eAAe;EACf;AACF;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,6BAA6B;EAC7B,cAAc;EACd,WAAW;AACb;AACA;EACE,eAAe;EACf,SAAS;AACX;;AAEA;EACE;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,UAAU;EACZ;AACF;;AAEA;;;;;EAKE,yCAAyC;EACzC,wDAAwD;AAC1D;;AAEA;IACI,mBAAmB;AACvB","sourcesContent":[".titleHeadWallet {\n  margin-top: 25px;\n}\n.walletHeader {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-top: 30px;\n  margin-bottom: 23px;\n}\n\n#walletTitle {\n  font-family: Silvana;\n  font-weight: 300;\n  font-size: 60px;\n  color: var(--main-link-color);\n  margin-top: 0;\n  margin-bottom: 0;\n  line-height: 60px;\n}\n\n#walletAddProduct a {\n  color: initial;\n  display: flex;\n  align-items: center;\n  font-size: 9px;\n  letter-spacing: 0.9px;\n  text-transform: uppercase;\n  color: var(--footer-selected-color);\n}\n\n#walletAddProduct a svg {\n  width: 44px;\n  height: 44px;\n  margin-left: 12px;\n}\n\n#walletProductBlock,\n.walletProductBlock {\n  display: flex;\n  flex-direction: column;\n  margin-bottom: 10px;\n  background-color: var(--background-color);\n  height: 28vh;\n  color: var(--footer-selected-color);\n}\n\n#walletProductName,\n.walletProductName {\n\tfont-weight: bold;\n  font-size: 25px;\n  text-transform: uppercase;\n  padding-top: 15px;\n  text-align: center;\n}\n\n#walletProductModel,\n.walletProductModel {\n\tfont-family: Silvana;\n  font-weight: 300;\n  text-align: center;\n  margin-top: 5px;\n}\n\n#walletProductPicture,\n.walletProductPicture {\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: contain;\n  flex-grow: 1;\n}\n\n/*//////////*/\n.productCardContent{\n  display: flex;\n  flex-direction: column;\n  height: 28vh;\n  color: #3c3c3b;\n  align-items: center;\n  justify-content: space-around;\n  background-color: #eee;\n\n}\n.productCardPicture{\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: contain;\n  flex-grow: 1;\n  width: 100%;\n}\n\n.productCardContent{\n  font-family: OpenSans;\n}\n\n.productCardTitle {\n  text-align: center;\n  border-bottom: rgb(255, 158, 23) solid 1px;\n}\n\n.productCard {\n  cursor: pointer;\n  position: relative;\n  background-color: #eee;\n  transition: transform 0.5s;\n}\n\n.productCard::after {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  transition: opacity 2s cubic-bezier(0.165, 0.84, 0.44, 1);\n  box-shadow: 0 8px 17px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.15);\n  content: \"\";\n  opacity: 0;\n  z-index: -1;\n}\n.productCard:hover::after, .productCardContent:focus::after {\n  opacity: 1;\n}\n\n.tabBtn {\n  background-color: white;\n  width: 100%;\n  border: solid 1px var(--main-hg-color);\n  font-size: 12px;\n  font-weight: bold;\n  text-transform: uppercase;\n  margin-top: 20px;\n  padding: var(--buttonPadding);\n  cursor: pointer;\n  display: block;\n  transition: background-color 0.5s ease-in-out;\n}\n\n.tabBtn:disabled {\n  opacity: 0.5;\n}\n\n.tabBtnSelected {\n  background-color: var(--main-hg-color);\n}\n\n.invoiceMissing {\n  color: black;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;\n  font-weight: lighter;\n  border: 1px solid black;\n  border-radius: 25px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 25px;\n  padding: 10px;\n  font-style: italic ;\n}\n\n.invoiceMissing p{\n  margin: 0;\n}\n\n.productCardHeader {\n  justify-content: flex-end !important;\n}\n\n.invoiceVerif {\n  color: red;\n  border: 1px solid red;\n  border-radius: 25px;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;\n  font-weight: lighter;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 25px;\n  padding: 10px;\n  background-color: rgba(252,0,0,0.1);\n}\n\n.invoiceVerif p{\n  margin: 0;\n}\n\n\n.container__switch {\n  width: 192px;\n  height: 42px;\n  background: #FFFFFF 0% 0% no-repeat padding-box;\n  border: 1px solid #121212;\n  border-radius: 10px;\n  opacity: 0.1;\n  display: flex;\n}\n\n.container__switch__left {\n  text-align: left;\n  font-size: 15px;\n  font-weight: 600;\n  letter-spacing: 0px;\n  color: #FFFFFF;\n  opacity: 1;\n  left: 241px;\n  width: 53px;\n  height: 19px;\n  width: 50%;\n  font-family: 'Plus Jakarta Sans';\n}\n\n.container__switch__right {\n  text-align: left;\n  font-weight: 600;\n  font-size: 15px;\n  letter-spacing: 0px;\n  color: #FFFFFF;\n  opacity: 1;\n  left: 241px;\n  width: 53px;\n  height: 19px;\n  width: 50%;\n  font-family: 'Plus Jakarta Sans';\n}\n\n.container__switcher {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center\n}\n\n.container__switcher span.switcher {\n  position: relative;\n  width: 192px;\n  height: 42px;\n  border-radius: 10px;\n  margin: 40px 0\n}\n\n.container__switcher span.switcher input {\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n  position: relative;\n  width: 192px;\n  height: 42px;\n  border-radius: 10px;\n  background-color: transparent;\n  outline: 0;\n  font-family: Poppins;\n  cursor: pointer;\n  border: 1px solid rgba(18,18,18,0.1);\n  border-radius: 10px;\n  display: flex;\n}\n\n@media (max-width: 600px) {\n  .container__switcher span.switcher input {\n    width:100%\n  }\n}\n\n.container__switcher span.switcher input:after,.container__switcher span.switcher input:before {\n  z-index: 2;\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  color: #fff\n}\n\n.container__switcher span.switcher input:before {\n  content: var(--jour-actuel);\n  left: 20px;\n  font-family: 'Plus Jakarta Sans';\n  font-size: 15px;\n  width: 100%;\n  font-weight: 700;\n  height: 100%;\n  left: 0;\n  padding: 8px;\n  padding-left: 21px;\n}\n\n.container__switcher span.switcher input:after {\n  content: var(--jour-suivant);\n  right: 20px;\n  font-family: 'Plus Jakarta Sans';\n  font-size: 15px;\n  letter-spacing: 0;\n  font-weight: 700;\n}\n\n.container__switcher span.switcher label {\n  z-index: 1;\n  position: absolute;\n  top: 0;\n  bottom: -3px;\n  border-radius: 8px\n}\n\n.container__switcher span.switcher.switcher-1 input {\n  transition: .25s -.1s\n}\n\n.container__switcher span.switcher.switcher-1 input:checked {\n  background-color: #fff\n}\n\n.container__switcher span.switcher.switcher-1 input:checked:before {\n  color: #fff;\n  transition: color .5s .2s\n}\n\n.container__switcher span.switcher.switcher-1 input:checked:after {\n  color: #000000;\n  transition: color .5s\n}\n\n.container__switcher span.switcher.switcher-1 input:checked+label {\n  left: 5px;\n  top: 3px;\n  right: 98px;\n  height: 36px;\n  background-color: var(--main-hg-color);\n  transition: left .5s,right .4s .2s;\n  box-shadow: 0 4px 10px rgba(0,0,0,.1)\n}\n\n@media (max-width: 300px) {\n  .container__switcher span.switcher.switcher-1 input:checked+label {\n    right:100px\n  }\n}\n\n.container__switcher span.switcher.switcher-1 input:not(:checked) {\n  transition: background .5s -.1s\n}\n\n.container__switcher span.switcher.switcher-1 input:not(:checked):before {\n  background-color: var(--main-hg-color);\n  transition: color .5s\n}\n\n.container__switcher span.switcher.switcher-1 input:not(:checked):after {\n  color: #fff;\n  transition: color .5s .2s\n}\n\n.container__switcher span.switcher.switcher-1 input:not(:checked)+label {\n  left: 102px;\n  top: 3px;\n  height: 36px;\n  right: 5px;\n  background-color: var(--main-hg-color);\n  transition: left .4s .2s,right .5s,background .35s -.1s;\n  box-shadow: 0 4px 10px rgba(0,0,0,.1)\n}\n\n@media (max-width: 600px) {\n  .container__switcher span.switcher.switcher-1 input:not(:checked)+label {\n    left:50% !important;\n  }\n\n  .container__switcher span.switcher.switcher-1 input:checked+label {\n    right: 50%;\n  }\n}\n\n@media (max-width: 300px) {\n  .container__switcher span.switcher.switcher-1 input:not(:checked) + label {\n    left:100px\n  }\n}\n\n.container__toggle__switch {\n  height: fit-content;\n  margin-top: 20px;\n  margin-bottom: 20px;\n}\n.container__toggle__switch button {\n  height: fit-content;\n  margin-top: 0;\n  padding: 6px 5px;\n}\n\n.container__toggle__switch button:first-child {\n  border-radius: 10px 0px 0 10px;\n}\n\n.container__toggle__switch button:last-child {\n  border-radius: 0 10px 10px 0;\n}\n\n.togglebutton {\n  padding-top: 28px;\n}\n\n.deleteBanner {\n  border: solid 1px rgb(255, 158, 23);\n  border-radius: 10px;\n  padding: 5px;\n  background-color: rgba(255, 158, 23, 0.3);\n  color: black;\n  /*width: 30%;*/\n  display: flex;\n  justify-content: space-between;\n}\n\n.deleteCancel {\n  background-color: transparent;\n  border: solid 1px rgb(255, 158, 23);\n  border-radius: 10px;\n  font-size: 12px;\n  font-weight: bold;\n  text-transform: uppercase;\n  padding: 10px;\n  cursor: pointer;\n  transition: background-color 0.3s ease\n}\n\n.deleteCancel:hover {\n  background-color: rgba(255, 158, 23, 0.3);\n}\n\n.containerLanguage {\n  max-width: calc(100vw - 50px);\n  margin: 0 auto;\n  z-index: 11;\n}\n.selectLanguage {\n  margin-top: 5px;\n  width: 5%;\n}\n\n@media (max-width: 1200px) {\n  .selectLanguage {\n    width: 10%;\n  }\n}\n\n@media (max-width: 600px) {\n  .selectLanguage {\n    width: 20%;\n  }\n}\n\n.ui.selection.active.dropdown:hover,\n.ui.selection.active.dropdown:focus,\n.ui.selection.dropdown:focus,\n.ui.selection.active.dropdown .menu\n{\n  border-color: rgb(255, 158, 23)!important;\n  box-shadow: 0 2px 3px 0 rgba(255, 158, 23,.15)!important;\n}\n\n.walletProducts:last-child {\n    margin-bottom: 50px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
